import { Link } from "react-router-dom";
import { useAuthStore } from "@/stores/authStore";
import { Home, ArrowLeft } from "lucide-react";

export function NotFound() {
  const { isAuthenticated } = useAuthStore();

  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-primary-50 via-white to-sales-50">
      <div className="text-center max-w-md">
        <h1 className="text-6xl font-bold gradient-text mb-4">404</h1>
        <h2 className="text-2xl font-bold text-gray-800 mb-4">Page Not Found</h2>
        <p className="text-gray-600 mb-8">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          {isAuthenticated ? (
            <Link
              to="/dashboard"
              className="btn-primary"
            >
              <Home className="h-5 w-5" />
              Go to Dashboard
            </Link>
          ) : (
            <Link
              to="/"
              className="btn-primary"
            >
              <ArrowLeft className="h-5 w-5" />
              Back to Home
            </Link>
          )}
        </div>
      </div>
    </div>
  );
}
